import angular from 'angular';
import addAssetSupplierModal from './addAssetSupplierModal';

export default angular
  .module('components.addAssetSupplierModal', [])
  .component('addAssetSupplierModal', addAssetSupplierModal).name;
